import { ColumnDef } from '@tanstack/react-table';

import { TimePicker } from '@/components/shared/time-picker';
import OrderCutoffDaysSelect from '@/components/restaurant/order-cutoff-times/order-cutoff-days-select';

import { TType } from '@/types/general';
import { OrderCutoffTimeFormItem } from '@/types/order-cutoff-times';

export const columns = (
  t: TType,
  orderCutoffTimes: OrderCutoffTimeFormItem[],
  setOrderCutoffTimes: (orderCutoffTimes: OrderCutoffTimeFormItem[]) => void,
): ColumnDef<OrderCutoffTimeFormItem>[] => [
  {
    accessorKey: 'day',
    header: t('order-cutoff-times.day'),
    enableSorting: false,
    cell: (cellData) => {
      return (
        <>
          {t(
            `order-cutoff-times.days-in-week.${cellData.row.original.day_of_week}`,
          )}
        </>
      );
    },
  },
  {
    accessorKey: 'orders-untill',
    enableSorting: false,
    header: t('order-cutoff-times.orders-until'),
    cell: function Cell(cellData) {
      const handleTimeChange = (hour: string, minute: string) => {
        setOrderCutoffTimes(
          orderCutoffTimes.map((item) =>
            item.day_of_week === cellData.row.original.day_of_week
              ? { ...item, cutoff_time: { hour, minute } }
              : item,
          ),
        );
      };
      return (
        <TimePicker
          time={cellData.row.original.cutoff_time}
          handleTimeChange={handleTimeChange}
        />
      );
    },
  },
  {
    accessorKey: 'details',
    header: '',
    enableSorting: false,
    cell: function Cell(cellData) {
      return (
        <OrderCutoffDaysSelect
          value={`${
            orderCutoffTimes.find(
              (item) => item.day_of_week === cellData.row.original.day_of_week,
            )?.days_in_advance
          }`}
          onChange={(value) => {
            setOrderCutoffTimes(
              orderCutoffTimes.map((item) =>
                item.day_of_week === cellData.row.original.day_of_week
                  ? { ...item, days_in_advance: +value }
                  : item,
              ),
            );
          }}
        />
      );
    },
  },
];
